module.exports = __webpack_public_path__ + "static/media/slide 2.f2c6b708.jpg";